module.exports = new __parcel__URL__("walk.1187eb9d.mpeg").toString();